//import { Typography } from '@mui/material';
import React from 'react';
import { Route } from 'react-router';
import { DataProviderCache } from '../../data/DataProviders/DataProviderCache';
import { DeviceDetailsProvider } from '../../data/DataProviders/DeviceDetailsProvider';
import { MeshDeviceDetailsProvider } from '../../data/DataProviders/MeshDeviceDetailsProvider';
import { DeviceMasterProvider } from '../../data/DataProviders/DeviceMasterProvider';
import { SierraGatewayDeviceDetailsProvider } from '../../data/DataProviders/SierraGatewayDeviceDetailsProvider';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import { getAppRouteCacheName, AppRoutes } from '../../routes';

import { AddChildDevice } from './AddChildDevice';
import { AddStarFishChildDevice } from './AddStarFishChildDevice';
import { DeviceProfile } from './DeviceProfile';
import { PxDeviceProfile } from './PxDeviceProfile';
import { MeshDeviceProfile } from './MeshDeviceProfile';
import { StarfishDeviceProfile } from './StarfishDeviceProfile';

import { StarfishGatewayDeviceDetailsProvider } from '../../data/DataProviders/StarfishGatewayDeviceDetailsProvider';

export const DeviceProfileContainer: React.FC = () => {
    const currentAppRoute = useCurrentAppRoute();
    const selectedOrganization = useSelectedOrganizationData();

    return (
        <>
            {(currentAppRoute.type === 'DeviceProfile' ||
                currentAppRoute.type === 'EditConnectedDevice' ||
                currentAppRoute.type === 'AddChildDevice') &&
                isRecordFound(selectedOrganization) &&
                'locationId' in currentAppRoute &&
                'deviceId' in currentAppRoute &&
                'siteId' in currentAppRoute && (
                    <>
                        <DataProviderCache for={getAppRouteCacheName(AppRoutes.DeviceProfile)}>
                            <SierraGatewayDeviceDetailsProvider
                                deviceId={currentAppRoute.deviceId}
                                siteId={currentAppRoute.siteId}
                            >
                                <DeviceMasterProvider>
                                    <Route path={[AppRoutes.DeviceProfile, AppRoutes.EditConnectedDevice]}>
                                        <DeviceProfile />
                                    </Route>
                                    <Route exact path={AppRoutes.AddChildDevice}>
                                        <DataProviderCache for={'device-details'}>
                                            <DeviceDetailsProvider deviceId={currentAppRoute.deviceId} recursive={true}>
                                                <AddChildDevice />
                                            </DeviceDetailsProvider>
                                        </DataProviderCache>
                                    </Route>
                                </DeviceMasterProvider>
                            </SierraGatewayDeviceDetailsProvider>
                        </DataProviderCache>
                    </>
                )}

            {currentAppRoute.type === 'PxDeviceProfile' &&
                isRecordFound(selectedOrganization) &&
                'locationId' in currentAppRoute &&
                'deviceId' in currentAppRoute &&
                'siteId' in currentAppRoute && (
                    <>
                        <DataProviderCache for={getAppRouteCacheName(AppRoutes.PxDeviceProfile)}>
                            <DeviceDetailsProvider deviceId={currentAppRoute.deviceId} recursive={true}>
                                <Route path={[AppRoutes.PxDeviceProfile]}>
                                    <PxDeviceProfile />
                                </Route>
                            </DeviceDetailsProvider>
                        </DataProviderCache>
                    </>
                )}
            {(currentAppRoute.type === 'StarfishDeviceProfile' ||
                currentAppRoute.type === 'EditStarfishConnectedDevice') &&
                isRecordFound(selectedOrganization) &&
                'locationId' in currentAppRoute &&
                'deviceId' in currentAppRoute &&
                'siteId' in currentAppRoute && (
                    <>
                        <DataProviderCache for={getAppRouteCacheName(AppRoutes.StarfishDeviceProfile)}>
                            <StarfishGatewayDeviceDetailsProvider deviceId={currentAppRoute.deviceId}>
                                <Route path={[AppRoutes.StarfishDeviceProfile]}>
                                    <StarfishDeviceProfile />
                                </Route>
                            </StarfishGatewayDeviceDetailsProvider>
                        </DataProviderCache>
                    </>
                )}
            {currentAppRoute.type === 'AddStarFishChildDevice' &&
                isRecordFound(selectedOrganization) &&
                'locationId' in currentAppRoute &&
                'deviceId' in currentAppRoute &&
                'siteId' in currentAppRoute && (
                    <>
                        <DataProviderCache for={getAppRouteCacheName(AppRoutes.AddStarFishChildDevice)}>
                            {
                                <Route exact path={AppRoutes.AddStarFishChildDevice}>
                                    <DataProviderCache for={'device-details'}>
                                        <DeviceMasterProvider>
                                            <StarfishGatewayDeviceDetailsProvider deviceId={currentAppRoute.deviceId}>
                                                <AddStarFishChildDevice />
                                            </StarfishGatewayDeviceDetailsProvider>
                                        </DeviceMasterProvider>
                                    </DataProviderCache>
                                </Route>
                            }
                        </DataProviderCache>
                    </>
                )}

            {(currentAppRoute.type === 'MeshDeviceProfile' || currentAppRoute.type === 'AcquireSubscription') &&
                isRecordFound(selectedOrganization) &&
                'locationId' in currentAppRoute &&
                'deviceId' in currentAppRoute &&
                'siteId' in currentAppRoute && (
                    <>
                        <DataProviderCache for={getAppRouteCacheName(AppRoutes.MeshDeviceProfile)}>
                            <MeshDeviceDetailsProvider deviceId={currentAppRoute.deviceId}>
                                <Route path={[AppRoutes.MeshDeviceProfile, AppRoutes.AcquireSubscription]}>
                                    <MeshDeviceProfile />
                                </Route>
                            </MeshDeviceDetailsProvider>
                        </DataProviderCache>
                    </>
                )}
        </>
    );
};
